import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
// Core components
import Button from 'yoda-core-components/lib/components/Button';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
// Site Components
import User from 'yoda-site-components/lib/helpers/User/User';
import YodaDropdown from 'yoda-site-components/lib/components/YodaDropdown/YodaDropdown';
import * as MTLactions from 'yoda-site-components/lib/actions/SavedListToolTip';
import map from 'lodash/map';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { bindActionCreators } from 'redux';
import ModalBox from 'yoda-core-components/lib/deprecated/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Input from 'yoda-core-components/lib/components/Input/Input';
import { isLegacyAccessTokenMethods } from 'yoda-core-components/lib/helpers/Utils/Utils';
import * as actions from '../../../actions/MyListAction';
import * as styles from './Move.css';
import {
    createDropdownMessagesTexts,
    createDropdownPreferences,
} from '../../../selectors/createDropdownSelector';
import { addSavedItemToLocal } from '../../../common/getSavedItems';

const cx = classNames.bind(styles);

const config = {
    regex: {
        listName: /^.{4,24}$/,
    },
    defaultList: {
        name: 'My Favorites',
        value: 'myFavorites',
        href: '/mylist?id=myFavorites',
    },
};

class Move extends Component {
    static propTypes = {
        myListsDetails: PropTypes.objectOf.isRequired,
        actions: PropTypes.shape({
            createList: PropTypes.func,
            addToListEventSuccess: PropTypes.func,
            addToList: PropTypes.func,
            moveToList: PropTypes.func,
            movedToList: PropTypes.func,
            moveToListEventSuccess: PropTypes.func,
            moveToListSuccess: PropTypes.func,
        }).isRequired,
        messagesTexts: PropTypes.objectOf.isRequired,
        preferences: PropTypes.objectOf.isRequired,
        listId: PropTypes.string.isRequired,
        productId: PropTypes.string.isRequired,
        movedToList: PropTypes.objectOf(PropTypes.object).isRequired,
        moveToListSuccess: PropTypes.func,
        clickHandler: PropTypes.func.isRequired,
        showTopLevelMessage: PropTypes.func.isRequired,
        createList: PropTypes.func.isRequired,
        addToListFlag: PropTypes.bool,
        isTrendingList: PropTypes.bool,
        isSharedView: PropTypes.bool,
        itemId: PropTypes.string.isRequired,
        ppId: PropTypes.string.isRequired,
        addToListSuccess: PropTypes.func,
        accountId: PropTypes.string,
        openSlider: PropTypes.func,
        closeMoveModal: PropTypes.func,
        showMoveModal: PropTypes.bool,
        title: PropTypes.string,
        context: PropTypes.object,
    };

    static defaultProps = {
        addToListFlag: false,
        moveToListSuccess: noop,
        addToListSuccess: noop,
        openSlider: noop,
        closeMoveModal: noop,
        accountId: '',
        isSharedView: '',
        isTrendingList: '',
        showMoveModal: false,
        title: '',
        context: {},
    };

    constructor(props) {
        super(props);
        const accountId = TokenProvider.get('ACCOUNT_ID');
        const enableLegacyAccessTokenMethods = isLegacyAccessTokenMethods(this.props.context);
        const token = enableLegacyAccessTokenMethods
            ? TokenProvider.get('Access_Token')
            : undefined;
        this.renderForm = this.renderForm.bind(this);
        this.state = {
            showError: false,
            title: '',
            selectVal: '',
            token,
            accountId,
            setMyListNameLocal: '',
        };
        this.handleChange = this.handleChange.bind(this);
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            movedToList,
            moveToListSuccess,
            addToListSuccess,
            messagesTexts,
            showTopLevelMessage,
            clickHandler,
            addToListFlag,
            myListsDetails: {
                listItems,
                createdItem,
                requestFrom = '',
                isSuccess,
                createListError = {},
            },
        } = nextProps;
        let targetListName = '';
        /* istanbul ignore next */
        if (get(listItems, 'listData')) {
            for (let idx = 0; idx < listItems.listData.length; idx += 1) {
                /* istanbul ignore if */
                if (listItems.listData[idx].id === this.state.selectVal) {
                    targetListName = listItems.listData[idx].name;
                }
            }
        } else {
            targetListName = config.defaultList.name;
        }
        /* istanbul ignore else */
        if (!isEmpty(movedToList) && movedToList?.status === 204) {
            moveToListSuccess(targetListName, this.state.selectVal);
            clickHandler();
        }

        /* istanbul ignore else */
        if (!isEmpty(movedToList) && movedToList?.status === 412) {
            this.setState({
                showMoveErr: true,
                showMoveErrMsg: this.mapErrorMessage(get(movedToList, 'data', {})),
            });
        }

        /* istanbul ignore if */
        if (!isEmpty(movedToList) && movedToList?.status === 201 && addToListFlag) {
            addToListSuccess(targetListName, this.state.selectVal);
            clickHandler();
        }

        if (requestFrom === 'POST' && isSuccess) {
            showTopLevelMessage('success', messagesTexts.successMessage);
            if (addToListFlag) {
                this.addToList(createdItem.id);
            } else {
                this.moveList(createdItem.id);
            }
            clickHandler();
            setTimeout(() => {
                this.redirectToList(createdItem.id);
            }, 2000);
        } else if (requestFrom === 'POST' && !isSuccess) {
            if (movedToList?.status !== 204) {
                showTopLevelMessage('error', createListError.serviceErrorMessage);
            }
        }
    }

    handleChange(selectVal) {
        const {
            addToListFlag,
            isTrendingList,
            isSharedView,
            addToListSuccess,
            clickHandler,
            actions: { addToListEventSuccess },
        } = this.props;
        if (addToListFlag) {
            const view = isTrendingList || isSharedView;
            if (view && selectVal === 'myFavorites' && !User.isUserLoggedIn()) {
                const { ppId, itemId } = this.props;
                const total = addSavedItemToLocal({ id: ppId, itemId });
                const analyticsData = {
                    listType: '',
                    product: [
                        {
                            productInfo: {
                                productPPID: ppId,
                            },
                        },
                    ],
                    itemsSavedForLater: total,
                };
                analyticsData.listType = 'my fav';
                if (total !== -1) {
                    addToListSuccess(config.defaultList.name, selectVal);
                    addToListEventSuccess(analyticsData);
                    clickHandler();
                }
            } else {
                this.addToList(selectVal);
            }
        } else {
            this.moveList(selectVal);
        }
        this.setState({ selectVal, showMoveErr: false, showMoveErrMsg: '' });
    }

    getSelectedValue = (listNames) => {
        const { selectVal } = this.state;
        if (selectVal) {
            const data = listNames.filter((element) => element.value === selectVal);
            return data[0].name;
        }
        return 'Select a List';
    };

    redirectToList = (id) => {
        const url = `/mylist?id=${id}`;
        window.location.assign(url);
    };

    resetError = () => {
        if (this.state.showError) this.setState({ showError: false });
    };

    parseSortOptions = (sortOptions) =>
        sortOptions.map((item) => ({
            displayKey: item.name,
            value: item.value,
        }));

    addToList = (value) => {
        const {
            ppId,
            itemId,
            actions: { addToList },
        } = this.props;
        const { token, accountId } = this.state;
        const addToListPayLoad = [
            {
                product: {
                    id: ppId,
                },
                itemId,
                quantity: 1,
            },
        ];
        addToList(value, accountId, token, { listId: value, pdpPayload: addToListPayLoad }, 0);
    };

    moveList = (value) => {
        const {
            listId,
            productId,
            actions: { moveToList, moveToListEventSuccess },
        } = this.props;
        moveToList(
            listId,
            productId,
            [
                {
                    op: 'replace',
                    path: '/listId',
                    value,
                },
            ],
            '',
            ''
        );
        moveToListEventSuccess();
    };

    checkAuth = () => {
        if (!User.isUserLoggedIn()) {
            this.props.openSlider();
            return false;
        }
        return true;
    };

    createListSubmit = (e) => {
        e.preventDefault();
        const { messagesTexts, createList } = this.props;
        if (this.checkAuth()) {
            const name = get(e.target, 'addListName.value', '').trim();
            if (!name) {
                this.setState({ showError: true, title: messagesTexts.emptyListNameMessage });
                return;
            }

            if (!config.regex.listName.test(name)) {
                this.setState({ showError: true, title: messagesTexts.invalidListNameMessage });
                return;
            }

            // Form is validated
            // lets move forward
            this.resetError();
            createList({ name });
        }
        this.setState({ showMoveErr: false, showMoveErrMsg: '' });
    };

    createNewListChange = (value) => {
        const { messagesTexts, actions } = this.props;
        const name = value.trim();
        actions.clearListError();
        if (!config.regex.listName.test(name)) {
            if (name.length > 24) {
                this.setState({ showError: true, title: messagesTexts.invalidListNameMessage });
                return;
            }
        } else {
            this.setState({ showError: false });
        }
        this.setState({ setMyListNameLocal: value });
    };

    mapErrorMessage = (error) => {
        const {
            preferences: { errorMessages = {} },
        } = this.props;
        // default message
        let message = get(errorMessages, 'DEFAULT', '');
        const serviceErrorCode = error.errorCode;

        // if we have FE mapping to overrride message for errorCode
        if (errorMessages[serviceErrorCode]) {
            message = errorMessages[serviceErrorCode];
        } else if (error.errorMessage) {
            // Otherwise Error from Service
            message = error.errorMessage;
        }
        // If both doesnt match, default message will be taken

        return message;
    };

    renderErrorMessage = () => {
        const {
            myListsDetails: { createListError },
        } = this.props;
        return this.mapErrorMessage(createListError);
    };

    renderToolTipContent = (isError) => {
        let message = '';
        if (isError) {
            message = this.renderErrorMessage();
        }

        return this.renderForm(message);
    };

    renderForm(message) {
        const { messagesTexts } = this.props;
        const { showError, title, setMyListNameLocal } = this.state;
        let errorMessage = '';
        let showErr = false;
        if (message) {
            errorMessage = message;
            showErr = true;
        } else if (title) {
            errorMessage = title;
            showErr = showError;
        }
        return (
            <>
                <form onSubmit={this.createListSubmit} noValidate>
                    <fieldset>
                        <div
                            className={`${cx('formGroup')} ${dt([
                                'h-12',
                                'text-center',
                                'flex',
                                'justify-center',
                                'mt-6',
                            ])}`}
                        >
                            <Input
                                name="addListName"
                                type="text"
                                placeholder="Create New List"
                                value={setMyListNameLocal}
                                onChange={this.createNewListChange}
                                theme={dt([
                                    'w-full',
                                    'text-black',
                                    'text-normal',
                                    'py-0',
                                    'pl-5',
                                    'pr-4',
                                    'border',
                                    'border-solid',
                                    'border-gray-60',
                                    'border-r-0',
                                    'outline-none',
                                    'rounded-l-lg',
                                    'rounded-r-none',
                                    'disabled:opacity-70',
                                    showErr && 'border-error-border',
                                    showErr && 'border-2',
                                    'h-full',
                                ])}
                            />
                            <Button
                                type="submit"
                                size="Md"
                                automationId="add-to-the-list"
                                className={dt(['!rounded-none', '!rounded-r-lg', 'w-20'])}
                            >
                                {messagesTexts.Add}
                            </Button>
                        </div>
                    </fieldset>
                </form>
                {showErr && (
                    <div className={cx('message')} data-automation-id="move-list-error">
                        <p className={dt(['text-small', 'text-error-border', 'h-6'])}>
                            {errorMessage}
                        </p>
                    </div>
                )}
            </>
        );
    }

    render() {
        const {
            myListsDetails,
            listId,
            accountId,
            addToListFlag,
            showMoveModal,
            closeMoveModal,
            title,
        } = this.props;
        const { listItems } = myListsDetails;
        const requestObj = { ...myListsDetails };
        delete requestObj.listItems;
        let listnames = [];
        const isError = !isEmpty(myListsDetails.createListError);
        let disableSort = get(listItems, 'listData', []).length === 1 ? 'disable' : '';
        /* istanbul ignore if */
        if (this.state.accountId && this.state.accountId !== accountId && addToListFlag) {
            disableSort = '';
        }
        listnames = map(listItems.listData, (item) => ({ value: item.id, name: item.name }));
        /* istanbul ignore if */
        if (!addToListFlag) {
            listnames = listnames.filter((element) => element.value !== listId);
        }
        if (listnames.length === 0) {
            listnames.push(config.defaultList);
        }
        const { showMoveErr, showMoveErrMsg } = this.state;
        const iconDisableClassName = dt(['absolute', 'top-2', 'right-4']);
        return (
            <ModalBox
                onClose={closeMoveModal}
                showModal={showMoveModal}
                defaultHeader
                title={title}
                modalHeaderTheme={dt(['items-center'])}
                modalTitleTheme={dt(['text-left', 'sm:text-xlarge', 'lg:text-2xlarge'])}
                modalContentTheme={dt(['mt-6', 'overflow-y-visible'])}
            >
                <div className={`${cx('moveWrapper')} ${dt(['smOnly:h-[calc(100vh-160px)]'])}`}>
                    <div
                        className={`${cx('tooltip')} ${dt([
                            'block',
                            'bg-white',
                            'h-auto',
                            'w-auto',
                            'overflow-visible',
                        ])}`}
                    >
                        <div
                            className={`${cx('sortWrapperDesktop', disableSort)} ${dt([
                                'inline-block',
                                'border',
                                'border-solid',
                                'border-gray-60',
                                'rounded-lg',
                                'w-full',
                                'h-12',
                                !showMoveErrMsg && 'mb-6',
                            ])}`}
                        >
                            <YodaDropdown
                                dataSource={this.parseSortOptions(listnames)}
                                defaultValue={this.getSelectedValue(listnames)}
                                onChange={this.handleChange}
                                automationId="sortDropdown"
                                theme={`${cx('dropdownWrapperTheme', disableSort)} ${dt([
                                    '!ml-0',
                                    'sm:!block',
                                    'pl-5',
                                    'pt-2',
                                    'pb-3',
                                    '!h-full',
                                ])}`}
                                listMobileTheme={dt(['sm:!hidden'])}
                                dropdownTheme={`${cx('dropThemeMove')} ${dt([
                                    'sm:!border',
                                    'sm:!border-solid',
                                    'sm:!border-gray-15',
                                    'bg-white',
                                    '!w-[calc(100%+22px)]',
                                    'top-[38px]',
                                    '!-right-[1px]',
                                    '!overflow-y-visible',
                                ])}`}
                                labelTheme={dt([
                                    '!min-w-[calc(100%-44px)]',
                                    'float-left',
                                    'pt-1',
                                    this.getSelectedValue(listnames) === 'Select a List'
                                        ? 'text-gray-60'
                                        : 'text-black',
                                    '!text-base',
                                    '!leading-6',
                                    this.getSelectedValue(listnames) === 'Select a List'
                                        ? 'italic'
                                        : ' not-italic',
                                    !this.state.selectVal && '!normal-case',
                                    disableSort === 'disable' && 'text-gray-40',
                                ])}
                                optionsTheme={dt([
                                    'sm:!text-black',
                                    'sm:!text-small',
                                    'sm:!font-normal',
                                    'p-2',
                                    'hover:bg-light-white',
                                ])}
                                scrollTheme={dt(['md:!max-h-[176px]', 'overflow-y-auto'])}
                                forceDesktop
                                tooltipWrapper={dt(['!w-full', 'h-6'])}
                                toolTip={dt(['w-full', 'h-full'])}
                                iconClassName={
                                    disableSort === 'disable'
                                        ? iconDisableClassName
                                        : dt(['float-right'])
                                }
                                isDisabled={disableSort === 'disable'}
                            />
                        </div>
                        {showMoveErr && (
                            <div className={cx('message')} data-automation-id="move-list-error">
                                <p className={dt(['text-small', 'text-error-border', 'h-6'])}>
                                    {showMoveErrMsg}
                                </p>
                            </div>
                        )}
                        <p
                            className={`${cx('horizantalLines')} ${dt([
                                'w-[100%]',
                                'text-center',
                                'border-b',
                                'border-solid',
                                'border-gray-15',
                                'my-3',
                                'mx-auto',
                                'h-0',
                            ])}`}
                        >
                            <span
                                className={dt([
                                    'relative',
                                    '-top-3.5',
                                    'font-semibold',
                                    'text-black',
                                    'text-medium',
                                    'bg-white',
                                    'px-2',
                                ])}
                                data-automation-id="or_text"
                            >
                                or
                            </span>
                        </p>
                        {this.renderToolTipContent(isError)}
                        <div className={dt(['mt-8', 'text-center'])}>
                            <Button
                                buttonType="Text"
                                size="Md"
                                automationId="cancel-move"
                                className={dt(['inline', 'w-auto'])}
                                onClick={closeMoveModal}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            </ModalBox>
        );
    }
}

const mapStateToProps = (store) => ({
    myListsDetails: store.MyList,
    messagesTexts: createDropdownMessagesTexts(store),
    preferences: createDropdownPreferences(store),
    movedToList: store.MTLSavedLists.movedToList,
    context: store.context,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...actions, ...MTLactions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Move);
